// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--q1unm";
export var figure = "styles-module--figure--hcet+";
export var image = "styles-module--image--ZpeHs";
export var caption = "styles-module--caption--ENoFC";